import React, {useState, useEffect} from "react";
import {useSelector} from "react-redux";
import LanguageService from "../api/language";
import TemplateAddEdit from "../common/Layout/templatePages/templateAddEdit";
import {getUrlVars} from "../utils/systemInfo";
import Swal from "sweetalert2";
import {useNavigate} from "react-router-dom";
import handleNavigate from "../common/customFunctions/handleNavigate";

const breadcrumbs = [
    {id: 0, name: "Home", href: "./"},
    {id: 1, name: "Language Api", href: "languageApi"},
    {id: 2, name: "Add/Edit Language", href: `addEditLanguage`}
];

function AddEditLanguage() {
    const organziation = useSelector(({organziation}) => organziation);
    const [languages, setLanguages] = useState([]);
    const languageID = getUrlVars()["id"] || "";
    const navigate = useNavigate();

    useEffect(() => {
        LanguageService.GetLanguageProfile(languageID.toString(), "", "", "active", organziation?.api_key_list?.[0]?.key).then((res) => {
            console.log(res);
            setLanguages(res.language_profile[0]);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organziation]);

    function handleSave(item) {
        if (item) {
            LanguageService.SetLanguageProfile(item.language_id, item.name, item.code, item.status, organziation?.api_key_list?.[0]?.key).then((res) => {
                if (res.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Language Updated Successfully',
                        showConfirmButton: true,
                        timer: 1500
                    })
                }
            })
        }
    }

     async function handleDelete(item) {
        const result = await Swal.fire({
            icon: "warning",
            title: "Are you sure?",
            text: "This will remove the language entry.",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                await LanguageService.SetLanguageProfile(
                    item.language_id,
                    item.name,
                    item.code,
                    "removed", // Status
                    organziation?.api_key_list?.[0]?.key
                );
                Swal.fire({
                    icon: "success",
                    title: "Deleted!",
                    text: "The language was removed.",
                    timer: 1000,
                    showConfirmButton: false,
                }).then(() => {
                    handleNavigate(null, navigate, "/languageApi");
                });
            } catch (err) {
                Swal.fire({
                    icon: "error",
                    title: "Delete Failed",
                    text: err?.toString() || "Unknown error"
                });
            }
        }
    }

    return (
        <TemplateAddEdit
            breadcrumbs={breadcrumbs}
            title="Add/Edit Language"
            gridCol={2}
            item={languages}
            dataToShow={[
                {key: "name", label: "Language Name", isRequired: true},
                {key: "code", label: "Code", isRequired: true},
                {key: "status", label: "Status", isRequired: true}
            ]}
            onSaveClick={(item) =>
                handleSave({
                    ...item,
                    apiKey: organziation?.api_key_list?.[0]?.key
                })
            }
            showDelete={!!languageID}
            onDeleteClick={(item) =>
                handleDelete({
                    ...item,
                    apiKey: organziation?.api_key_list?.[0]?.key
                })
            }
        />
    );
}

export default AddEditLanguage;
